import * as kakaoConfigJson from "./kakaoConfig.json";
import axios from "axios";

const kakaoConfigs = kakaoConfigJson;

export const kakaoConfig = {
  javaScriptKey: kakaoConfigs.javaScriptKey,
  restApiKey: kakaoConfigs.restApiKey,
  reDirectUri: kakaoConfigs.reDirectUri,
  grantType: kakaoConfigs.grantType,
};

const apiClient = axios.create({
  baseURL: "https://kauth.kakao.com/oauth",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  },
});

export default {
  async getToken(data: any) {
    let result = undefined;
    try {
      result = await apiClient.post("/token", data);
    } catch (error: any) {
      result = error.response;
    } finally {
      return result;
    }
  },
};
